import { MenuProps } from 'antd'

import { ReactNode, useMemo } from 'react'

import { RouteModulesMap } from 'routes/Dashboard/model'

import { modulesLink } from 'modules/Auth/model/modulesNames'
import { useGetModulesQuery } from 'modules/Auth/services/authApi'
import { ModuleName } from 'modules/Auth/types/api'

type AntMenuItem = NonNullable<MenuProps['items']>[number]
interface MenuItem extends Omit<AntMenuItem, 'children'> {
  label: ReactNode
  key: string
}
interface FilterMenuProps {
  menu: MenuItem[]
}
export interface FilterRoutesProps {
  routeModulesMap: RouteModulesMap
}
export const usePermissions = () => {
  const { data, isFetching, isLoading } = useGetModulesQuery()

  const availableModules: string[] = useMemo(() => {
    if (data?.success) {
      return data.result.map((module) => module.title) || []
    }

    return []
  }, [data])

  const availableModulesWithEdit: ModuleName[] = useMemo(() => {
    if (data?.success) {
      return data.result
        .filter((module) => module.action === 'edit')
        .map((module) => module.title)
    }

    return []
  }, [data])

  const filterMenuByPermissions = ({ menu }: FilterMenuProps) => {
    return (
      menu.filter((menuItem) =>
        availableModules.some(
          (moduleName) => moduleName === modulesLink[menuItem.key],
        ),
      ) || []
    )
  }

  const filterRoutesByPermissions = ({
    routeModulesMap,
  }: FilterRoutesProps) => {
    return Object.entries(routeModulesMap)
      .filter(([moduleName]) => availableModules.includes(moduleName))
      .flatMap(([, routes]) => routes)
  }

  return {
    availableModules,
    filterMenuByPermissions,
    filterRoutesByPermissions,
    isFetching,
    isLoading,
    availableModulesWithEdit,
  }
}
